import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const CommentThreads = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="comment-threads"
      viewBox="0 0 16 16"
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
      fill={fill}
    >
      <path id="Rectangle_2064" fill="none" d="M0 0H16V16H0z" />
      <g id="comment-threads-2" transform="translate(0.645 3.466)">
        <path id="Rectangle_3039" d="M0 0H9.086V1.136H0z" transform="translate(3.921 9.175)" />
        <path
          id="Path_17224"
          d="M18.768 100h-.591a.182.182 0 0 0-.177.177v.591a.182.182 0 0 0 .177.177h.591a.182.182 0 0 0 .177-.177v-.591a.182.182 0 0 0-.177-.177z"
          transform="translate(-16.109 -90.545)"
        />
        <path id="Rectangle_3040" d="M0 0H8.518V1.136H0z" transform="translate(5.624 6.336)" />
        <path
          id="Path_17225"
          d="M34 74.768a.182.182 0 0 0 .177.177h.591a.182.182 0 0 0 .177-.177v-.591a.182.182 0 0 0-.177-.177h-.591a.182.182 0 0 0-.177.177z"
          transform="translate(-30.218 -67.618)"
        />
        <path id="Rectangle_3041" d="M0 0H7.95V1.136H0z" transform="translate(3.921 2.929)" />
        <path
          id="Path_17226"
          d="M18.768 46h-.591a.182.182 0 0 0-.177.177v.591a.182.182 0 0 0 .177.177h.591a.182.182 0 0 0 .177-.177v-.591a.182.182 0 0 0-.177-.177z"
          transform="translate(-16.109 -42.927)"
        />
        <path id="Rectangle_3042" d="M0 0H13.06V1.136H0z" transform="translate(1.649 0.09)" />
        <path
          id="Path_17227"
          d="M2.768 20h-.591a.182.182 0 0 0-.177.177v.591a.182.182 0 0 0 .177.177h.591a.182.182 0 0 0 .177-.177v-.591A.182.182 0 0 0 2.768 20z"
          transform="translate(-2 -20)"
        />
      </g>
    </svg>
  );
};

CommentThreads.displayName = 'CommentThreads';
